export function getIsLowInventoryInGallery(product) {
  const lowInventoryThreshold = product?.low_inventory_threshold || 3;

  return product?.total_on_hand <= lowInventoryThreshold && product?.total_on_hand > 0;
}
